<template>
  <AuthenticatedLayout>
    <PageHeader
      title="Tenants"
    />

    <tenants-data-table />

  </AuthenticatedLayout>
</template>

<script lang="ts" setup>

import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import PageHeader from "@/components/PageHeader.vue";
import TenantsDataTable from "@/components/DataTables/TenantsDataTable.vue";
</script>
